import { useEffect, useRef, useState } from "react";

import Mainmenu from "../ChatFlow/MainMenu";
import you from "../../assets/images/boy.png";
import bot from "../../assets/images/happy.png";
import LoadingDots from "../../components/ChatFlow/LoadingDots";


const Lastmenu = () => {
  const [showFrame1, setShowFrame1] = useState(false);
  const [showFrame3, setShowFrame3] = useState(false);
  const [loading, setLoading] = useState(false);
  const chatRef = useRef(null);
  const [time] = useState(new Date().toLocaleTimeString());

  const handleShowFrame1 = () => {
    setShowFrame1(true);
    setShowFrame3(false);
    setLoading(true);
  };

  const handleShowFrame3 = () => {
    setShowFrame3(true);
    setShowFrame1(false);
    setLoading(true);
  };

  useEffect(() => {
    if (showFrame1 || showFrame3) {
      setTimeout(() => setLoading(false), 1000);
    }
  }, [showFrame1, showFrame3]);

  // Auto-scroll when new elements are added
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [showFrame1, showFrame3, loading]);

  return (
    <>
      <div className="frame1 animated-frame" style={{textAlign: 'center'}}>
        How can I help you now?
        <br />
        <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginTop: '1rem' }}>
        <button className="detatils-button2 " onClick={handleShowFrame1}>
          Main Menu
        </button>
        <button className="detatils-button2" onClick={handleShowFrame3}>
          Exit
        </button>
        </div>
      </div>

      <div className="chat-container" ref={chatRef}>
        {showFrame1 && (
          <>
            <div className="you-time">
              <img src={you} alt="boy" className="boy" />
              You {time}
            </div>
            <div className="you-message">
              <div className="frame2 animated-frame">Main Menu</div>
            </div>

            {loading ? (
              <div className="frame1 animated-frame">
                <LoadingDots />
              </div>
            ) : (
              <>
                <div className="chatbot">
                  <img src={bot} alt="bot" className="bot" />
                  <div className="chatbot-time">{time}</div>
                </div>
                <Mainmenu />
              </>
            )}
          </>
        )}

        {showFrame3 && (
          <>
            <div className="you-time">
              <img src={you} alt="boy" className="boy" />
              You {time}
            </div>
            <div className="you-message">
              <div className="frame2 animated-frame">Exit</div>
            </div>

            {loading ? (
              <div className="frame1 animated-frame">
                <LoadingDots />
              </div>
            ) : (
              <>
              <div className="chatbot">
                  <img src={bot} alt="bot" className="bot" />
                  <div className="chatbot-time">{time}</div>
                </div>
                <div className="frame1 animated-frame">
                  Thank You!, and I am Glad to Assist You.
                </div>
                {/* <Greetings /> */}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Lastmenu;
